// Eigenes Konferenz-Signaling, getrennt von signaling-protocol.ts (L16). Der Raum trägt nur
// Gate, Warteraum, Roster und Steuerbefehle. Medien (Publish/Subscribe, SDP, ICE) laufen komplett
// über LiveKit und sind NICHT Teil dieses Protokolls — wer was sendet, sagt LiveKit selbst
// (Participant-Identität, siehe conference-identity.ts). Seit 2026-09-25 ohne jede
// Cloudflare-Realtime-Adressierung (sessionId/trackName sind ersatzlos entfallen).

/** Roster-Eintrag für den Host (Cockpit). */
export type ConfGuest = { guestId: string; name: string; admitted: boolean; reconnecting: boolean };
/** Anderer zugelassener Gast — fürs Namensband bei Gästen und Sprecher:innen. */
export type ConfPeer = { guestId: string; name: string };
/** Sprecher:in im Raum (hat KEINEN Konferenz-Audio-Track — Audio läuft über L16). */
export type ConfSpeakerRef = { speakerId: string; name: string };

export type ConferenceMessage =
  // Gast → Raum
  | { type: 'HELLO'; guestId: string; name: string }
  | { type: 'BYE' }
  // Host → Raum
  | { type: 'HOST_HELLO' }
  | { type: 'ADMIT'; guestId: string }
  | { type: 'KICK'; guestId: string }
  | { type: 'END' }
  | { type: 'RECALIBRATE' }
  // Sprecher → Raum
  | { type: 'SPEAKER_HELLO'; speakerId: string; name: string }
  // Raum → Host
  | { type: 'ROSTER'; guests: ConfGuest[]; speakers: ConfSpeakerRef[] }
  // Raum → Gast / Sprecher
  | { type: 'WAITING' }
  | { type: 'ADMITTED' }
  | { type: 'PEERS'; guests: ConfPeer[]; speakers: ConfSpeakerRef[] }
  | { type: 'ROOM_FULL' }
  | { type: 'KICKED' }
  | { type: 'SESSION_ENDED' };

const KNOWN_TYPES = new Set([
  'HELLO', 'BYE',
  'HOST_HELLO', 'ADMIT', 'KICK', 'END', 'RECALIBRATE',
  'SPEAKER_HELLO',
  'ROSTER', 'WAITING', 'ADMITTED', 'PEERS', 'ROOM_FULL', 'KICKED', 'SESSION_ENDED',
]);

export function parseConferenceMessage(raw: string): ConferenceMessage {
  const obj = JSON.parse(raw);
  if (!obj || typeof obj !== 'object' || typeof obj.type !== 'string' || !KNOWN_TYPES.has(obj.type)) {
    throw new Error(`unknown conference message: ${String(raw).slice(0, 100)}`);
  }
  return obj as ConferenceMessage;
}

export function serializeConferenceMessage(msg: ConferenceMessage): string {
  return JSON.stringify(msg);
}
